import { useNostr } from '@nostrify/react';
import { useQuery } from '@tanstack/react-query';
import type { NostrEvent } from '@nostrify/nostrify';

/**
 * Hook to fetch like reactions (kind 7 with content "❤️") for a specific event
 */
export function useLikes(eventId: string) {
  const { nostr } = useNostr();

  return useQuery({
    queryKey: ['likes', eventId],
    queryFn: async (c) => {
      const signal = AbortSignal.any([c.signal, AbortSignal.timeout(3000)]);
      
      const reactions = await nostr.query(
        [
          {
            kinds: [7],
            '#e': [eventId],
            limit: 500,
          },
        ],
        { signal }
      );

      // Filter for heart reactions only
      const likes = reactions.filter((r) => r.content === '❤️' || r.content === '❤');
      
      return likes;
    },
    enabled: !!eventId,
  });
}

/**
 * Check if the current user has liked a specific event
 */
export function useHasLiked(eventId: string, userPubkey?: string) {
  const { data: likes } = useLikes(eventId);

  if (!userPubkey || !likes) {
    return false;
  }

  return likes.some((like) => like.pubkey === userPubkey);
}
